import React, { useContext, useEffect, useRef, useState } from 'react';
import { MLSMapContext } from '../../context/MLSMapContext';
import useOutsideClick from '../../hooks/useOutsideClick';
import mls_categories from '../../constants/mls_categories.json';

export default function MLSCategoryDropdown() {
  const dropdownRef = useRef();

  const {
    typeFilter,
    categoryFilter,
    setCategoryFilter,
    categoryDropdownVisible,
    setCategoryDropdownVisible,
  } = useContext(MLSMapContext);

  const [localCategoryFilter, setLocalCategoryFilter] = useState(
    categoryFilter
  );

  useEffect(() => {
    setLocalCategoryFilter(categoryFilter);
  }, [categoryFilter]);

  useOutsideClick(dropdownRef, categoryDropdownVisible, () => {
    setLocalCategoryFilter(categoryFilter);
    setCategoryDropdownVisible(false);
  });

  return (
    <div ref={dropdownRef} className="dropdown-sorting-container">
      <h2 className="dropdown-title">Category</h2>
      <button
        aria-label="Clear Type Dropdown"
        name="Clear Type Dropdown"
        type="button"
        className="mobile-dropdown-cancel btn btn--small"
        onClick={() => setCategoryDropdownVisible(false)}
      >
        Close
      </button>
      <section className="dropdown-sorting-inputs">
        {mls_categories
          .filter(category => category.type === typeFilter.value)
          .map((category, ind) => {
            const isChecked = localCategoryFilter.some(
              localCategory => localCategory.label === category.label
            );

            return (
              <label key={ind} htmlFor={`filters-type-${category.value}`}>
                <input
                  aria-label={`${category.label}`}
                  id={`filters-type-${category.value}`}
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => {
                    if (isChecked) {
                      // Remove
                      const localCategoryFilterCopy = [...localCategoryFilter];
                      setLocalCategoryFilter(
                        localCategoryFilterCopy.filter(
                          localCategory =>
                            localCategory.label !== category.label
                        )
                      );
                    } else {
                      // Add
                      setLocalCategoryFilter([
                        ...localCategoryFilter,
                        category,
                      ]);
                    }
                  }}
                />
                <p>{category.short_label}</p>
              </label>
            );
          })}
      </section>
      <section className="dropdown-actions mobile-center">
        <button
          aria-label="Apply Type Filter"
          name="Apply Type Filter"
          type="button"
          className="btn btn--dark btn--small"
          onClick={() => {
            setCategoryFilter(localCategoryFilter);
            setCategoryDropdownVisible(false);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Type Filter"
          name="Clear Type Filter"
          type="button"
          className="btn btn--light"
          onClick={() => {
            setLocalCategoryFilter([]);
            setCategoryFilter([]);
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
